import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledCashmanCasino = styled.div`
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 7px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 32px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(255, 255, 255, 0.25) inset;

  .cashman-bundle {
    &__sale-badge {
      position: absolute;
      top: -2px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      min-width: 80px;

      &__text {
        position: absolute;
        font-size: 12px;
        font-weight: 600;
        color: white;
        margin: unset;
        top: 2px;
        text-shadow: 0px 0px 2px #2b2b2b;
      }
    }

    &__products-container {
      position: relative;
      top: -10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      gap: 10px;
      justify-content: center;
    }

    &__product {
      box-sizing: border-box;
      width: 100%;
      min-height: 32px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      position: relative;
      display: flex;

      .product-img {
        min-width: 40px;
        max-width: 40px;
        display: flex;
        justify-content: center;
        position: relative;
      }

      &.main-product {
        img {
          position: absolute;
          height: 48px;
          width: 48px;
          top: calc(50% - 24px);
          left: -2px;
        }
      }

      &.secondary-product {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .product-img img {
          height: 36px;
          width: 36px;
        }

        .tooltip-container {
          height: 100%;
        }

        .tooltip-icon {
          height: 14px;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
          margin-left: 2px;
          margin-right: 8px;
        }

        .secondary-product__container {
          display: flex;
          align-items: center;
        }

        .product-quantity {
          font-size: 13px;
          font-weight: 700;
        }

        .product-rarity {
          display: flex;

          .product-rarity-stars {
            margin-left: 3px;
            display: flex;
            align-items: center;

            img {
              height: 8px;
            }
          }
        }

        .html-tooltip {
          display: flex;
          align-items: center;
        }
      }

      .text-container {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        font-size: 11px;

        &__quantity {
          font-size: 13px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          background: linear-gradient(
            180deg,
            #fff6aa 26.47%,
            #ffd614 55.25%,
            #d27300 82.35%
          );
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

          @media (min-width: ${breakpoints.mobileL}) {
            font-size: 14px;
          }
        }

        &__stroked {
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-decoration: line-through;
        }
      }
    }
  }
` as any;
